<div class="container-fluid" id="assessmentPrint">
    <div class="row mt-3">
        <div class="col-12">
            <div class="card-body tab2-card">
                <form [formGroup]="studentForm" class="needs-validation user-add">
                    <div class="row">
                        <div class="form-group col-3">
                            <label class="col-xl-12 col-md-12"><span style="visibility: hidden">*</span>
                                Class List</label>
                            <div class="col-xl-12 col-md-12">
                                <ng-select (change)="assessmentReport(); studentReport()"
                                           [items]="classDetails"
                                           bindLabel="class_name"
                                           bindValue="class_id"
                                           formControlName="class"
                                           placeholder="Class List">
                                </ng-select>
                            </div>
                        </div>
                        <div class="form-group col-3" *ngIf="assessmentShow">
                            <label class="col-xl-12 col-md-12"><span style="visibility: hidden">*</span>
                                Assessment List</label>
                            <div class="col-xl-12 col-md-12">
                                <ng-select (change)="studentGradeReport()"
                                           [items]="assessmentDetails"
                                           bindLabel="content_name"
                                           bindValue="content_id"
                                           formControlName="assessment"
                                           placeholder="Please Select"
                                           typeToSearchText=""
                                           multiple="true">
                                </ng-select>
                            </div>
                        </div>
                        <div class="form-group col-3" *ngIf="assessmentShow">
                            <label class="col-xl-12 col-md-12"><span style="visibility: hidden">*</span>
                                Student List</label>
                            <div class="col-xl-12 col-md-12">
                                <ng-select (change)="studentGradeReport()"
                                           [items]="studentDetails"
                                           bindLabel="student_name"
                                           bindValue="student_id"
                                           formControlName="student"
                                           placeholder="Please Select"
                                           typeToSearchText=""
                                           multiple="true">
                                </ng-select>
                            </div>
                        </div>
                        <div [ngClass]="assessmentShow == true ? 'col-3' : 'col-9'">
                            <div class="row group-btn mt-3">
                                <div class="col-12 text-right" *ngIf="assessmentReportShow">
                                    <button type="button" class="btn btn-primary" (click)="assessmentPrint()">print</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="row d-flex justify-content-between mt-3" *ngIf="assessmentReportShow">
        <div class="col-12">
            <div class="card p-3">
                <div class="row">
                    <div class="col-12">
                        <h3>Students in Performance Bands (%)</h3>
                        <div id="chart">
                            <apx-chart
                                    [series]="chartOptions.series"
                                    [chart]="chartOptions.chart"
                                    [dataLabels]="chartOptions.dataLabels"
                                    [plotOptions]="chartOptions.plotOptions"
                                    [responsive]="chartOptions.responsive"
                                    [xaxis]="chartOptions.xaxis"
                                    [legend]="chartOptions.legend"
                                    [fill]="chartOptions.fill"
                            ></apx-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-3">
            <div class="card p-3">
                <div class="row">
                    <div class="col-6">
                        <h3>Assessment Statistics</h3>
                    </div>
                    <div class="col-6 text-right">
                        <button type="button" class="btn btn-success" (click)="downloadExcelData()">Download CSV</button>
                    </div>
                    <div class="col-12 mt-2">
                        <div id="batchDelete" class="category-table custom-datatable transcation-datatable user-image">
                            <div class="table-responsive">
                                <angular2-smart-table [settings]="settings" [source]="listData" (userRowSelect)="viewDetail($event)"></angular2-smart-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row d-flex justify-content-center list-card mt-3" *ngIf="!assessmentReportShow">
        <div class="col-12">
            <button class="nodataList">{{message}}</button>
        </div>
    </div>
</div>
